import request from '../request'
import handler from '@/utils/responseHandler'

/*
  微信网页授权相关接口
  333131    微信授权-根据sessionid获取用户信息
*/
export default {
  '333008': (sessionid) =>
    request.ticket({
      url: '/gateway/gtgj/user',
      method: 'POST',
      data: {
        pid: 333131,
        sessionid
      },
      sidFields: ['uid', 'pid']
    }).then(handler.resBdData)
}



// WEBPACK FOOTER //
// ./src/api/wechat.js